import { render, staticRenderFns } from "./CompanyMyData.vue?vue&type=template&id=28a8823e&lang=html"
import script from "./CompanyMyData.vue?vue&type=script&lang=js"
export * from "./CompanyMyData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports